import React from "react";
import ChartSidebar from "./ChartSidebar";
const SidebarDashboard = (props) => {
  return (
    <div>
      <div className="col-12 side-bar-parent">
        <h3>فعال ترین کاربران 5 روز اخیر</h3>
      </div>

      <ChartSidebar data={props.chartSidebar} topUser={props.topUser} />
    </div>
  );
};

export default SidebarDashboard;
